/**
 * Counts number of anchor tags in an HTML string.
 * Scooped from https://stackoverflow.com/a/21870431
 *
 * @param  bodyHTML string      - Full HTML text to count anchor tags within
 * @return {number}             - Number of anchor tags counted
 */
export function countHtmlAnchorElements(bodyHTML: string): number {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(bodyHTML, 'text/html');

    return htmlDoc.getElementsByTagName('a').length;
}
